import { useCallback, useRef } from 'react';

/**
 * Bridge hook to replace window.curateComponent global
 * Provides explicit callback contract between Collection and Curate
 * Updated for simplified button-only interface
 */
export const useCurateBridge = () => {
  const curateRef = useRef(null);

  const setCurateRef = useCallback((ref) => {
    curateRef.current = ref;
  }, []);

  // Legacy methods for backward compatibility
  const setGameChips = useCallback((gameChips) => {
    if (curateRef.current?.setGameChips) {
      curateRef.current.setGameChips(gameChips);
    }
  }, []);

  const setInput = useCallback((input) => {
    if (curateRef.current?.setInput) {
      curateRef.current.setInput(input);
    }
  }, []);

  const sendMessage = useCallback((message) => {
    if (curateRef.current?.sendMessage) {
      curateRef.current.sendMessage(message);
    }
  }, []);

  // New simplified methods for button-only interface
  const showSimilarGames = useCallback((game) => {
    if (curateRef.current?.showSimilarGames) {
      curateRef.current.showSimilarGames(game);
    }
  }, []);

  const showComparison = useCallback((gameA, gameB) => {
    if (curateRef.current?.showComparison) {
      curateRef.current.showComparison(gameA, gameB);
    }
  }, []);

  const resetCurate = useCallback(() => {
    if (curateRef.current?.reset) {
      curateRef.current.reset();
    }
  }, []);

  return {
    curateRef,
    setCurateRef,
    // Legacy methods
    setGameChips,
    setInput,
    sendMessage,
    // New simplified methods
    showSimilarGames,
    showComparison,
    resetCurate,
  };
};
